import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Box,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add } from "@mui/icons-material";
import { getRowErrorMessages } from "./Errors";
import {
  validateNumber,
  validateNumberInput,
  validatePercentage,
} from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

const DropDownTable = ({
  inputData,
  tables,
  setTables,
  errors,
  setErrors,
  disabled,
  hide,
  field1
}) => {
  const [isFilled, setIsFilled] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [fieldToRemove, setFieldToRemove] = useState({
    tableIndex: null,
    rowIndex: null,
  });

  // Add a new row to a specific table
  const handleAddRow = (tableIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].rows.push({});
    setTables(updatedTables);
  };

  // Remove a row from a specific table
  // const handleDeleteRow = (tableIndex, rowIndex) => {
  //   const updatedTables = [...tables];
  //   updatedTables[tableIndex].rows.splice(rowIndex, 1);
  //   setTables(updatedTables);
  // };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
  };

  const confirmRemoveRow = () => {
    if (fieldToRemove) {
      const { tableIndex, rowIndex } = fieldToRemove;
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    }
    setOpenDialog(false);
  };

  const handleDeleteRow = (tableIndex, rowIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      if (
        Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
      ) {
        setOpenDialog(true);
        setFieldToRemove({ tableIndex, rowIndex });
        return newTables;
      }

      newTables[tableIndex].rows.splice(rowIndex, 1);
      return newTables;
    });
  };

  const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
    if (type === "percentage" && !validatePercentage(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;
    const updatedTables = [...tables];
    updatedTables[tableIndex].rows[rowIndex] = {
      ...updatedTables[tableIndex].rows[rowIndex],
      [fieldName]: value,
    };

    // If both totalGovernaceBody and governaceBody are filled, calculate the percentage
    const totalGovernaceBody =
      updatedTables[tableIndex].rows[rowIndex].totalGovernaceBody;
    const governaceBody =
      updatedTables[tableIndex].rows[rowIndex].governaceBody;

    if (totalGovernaceBody && governaceBody !== undefined) {
      const percentage = (governaceBody / totalGovernaceBody) * 100;
      updatedTables[tableIndex].rows[rowIndex].percentage =
        percentage.toFixed(3); // Store the calculated percentage
    } else {
      // If either field is empty, reset the percentage to an empty string
      updatedTables[tableIndex].rows[rowIndex].percentage = "";
    }

    // Clear errors for the current field if any
    const updatedErrors = { ...errors };
    if (
      updatedErrors[tableIndex] &&
      updatedErrors[tableIndex][rowIndex] &&
      updatedErrors[tableIndex][rowIndex][fieldName]
    ) {
      delete updatedErrors[tableIndex][rowIndex][fieldName];
      if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
        delete updatedErrors[tableIndex][rowIndex];
      }
      if (Object.keys(updatedErrors[tableIndex]).length === 0) {
        delete updatedErrors[tableIndex];
      }
    }

    setErrors(updatedErrors);
    setTables(updatedTables);
    checkIfAdded();
  };

  useEffect(() => {
    checkIfAdded();
  }, [tables, inputData]); // Run only when tables or inputData change

  const checkIfAdded = () => {
    tables.forEach((table, tableIndex) => {
      const rows = table?.rows || [];
      const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
      const filteredLastRow = Object.fromEntries(
        Object.entries(lastRow).filter(([key]) => key !== "_id")
      );

      const optionalLength = inputData?.[tableIndex]?.fields?.filter(
        (el) => el?.optional
      )?.length;
      console.log(optionalLength, "option");
      // Check if lastRow is fully filled
      const isComplete =
        Object.keys(filteredLastRow).length >=
          (inputData?.[tableIndex]?.fields?.length - optionalLength || 0) &&
        Object.values(filteredLastRow)?.every(
          (val) =>
            val !== undefined && val !== "" && val !== null && val?.length !== 0
        );
      console.log("complte", lastRow, isComplete);
      setIsFilled((prevState) => ({
        ...prevState,
        [tableIndex]: !isComplete, // true if incomplete, false if fully filled
      }));
    });
  };

  return (
    <Box>
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "1rem",
        }}
        gutterBottom
      >
        {inputData[0].title}
      </Typography>

      {/* Loop through tables */}
      {tables.map((table, tableIndex) => (
        <Box key={tableIndex} sx={{ mb: 4 }}>
          {/* Table */}
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
              marginLeft: "1rem",
              width: "98%",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1C486B" }}>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      borderRight: "1px solid #D3D3D3",
                    }}
                  >
                    S. No.
                  </TableCell>
                  {inputData[0].fields.map((field, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        fontWeight: 600,
                        borderRight: "1px solid #D3D3D3",
                        width: field.width,
                      }}
                    >
                      {field.title}
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {table.rows.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell
                      sx={{
                        borderRight: "1px solid #D3D3D3",
                        textAlign: "center",
                        width: "8%",
                      }}
                    >
                      {rowIndex + 1}.
                    </TableCell>
                    {inputData[0].fields.map((field, fieldIndex) => (
                      <TableCell
                        key={fieldIndex}
                        sx={{
                          borderRight: "1px solid #D3D3D3",
                          backgroundColor:
                            field.fieldName === "percentage" ? "#EFEFEF" : "",
                        }}
                      >
                        {field.type === "select" ? (
                          <TextField
                            select
                            disabled={disabled}
                            value={row[field.fieldName] || ""}
                            onChange={(e) =>
                              handleInputChange(
                                tableIndex,
                                rowIndex,
                                field.fieldName,
                                e.target.value,
                                field.type
                              )
                            }
                            sx={{
                              width: "150px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 0,
                                "& fieldset": {
                                  border: "none",
                                },
                              },
                              // "& .MuiSelect-select": {
                              //   padding: "8px",
                              // },
                            }}
                            SelectProps={{
                              native: true,
                            }}
                          >
                            <option value="" disabled>
                              {field.placeholder}
                            </option>
                            {field.options.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                          </TextField>
                        ) : (
                          <TextField
                            value={row[field.fieldName] || ""}
                            multiline
                            minRows={1}
                            disabled={field1===field?.fieldName ||disabled}
                            onChange={(e) =>
                              handleInputChange(
                                tableIndex,
                                rowIndex,
                                field.fieldName,
                                e.target.value,
                                field.type
                              )
                            }
                            size="small"
                            variant="standard"
                            InputProps={{ disableUnderline: true }}
                            placeholder={field.placeholder}
                            fullWidth
                          />
                        )}
                      </TableCell>
                    ))}

                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteRow(tableIndex, rowIndex)}
                        disabled={table.rows.length === 1 || disabled}
                        sx={{
                          opacity: table.rows.length === 1 ? 0.5 : 1,
                          cursor:
                            table.rows.length === 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1, ml: 2 }}>
            {Object.keys(errors).length > 0 &&
              getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                (errorMessage, idx) => (
                  <p
                    key={idx}
                    color="error"
                    variant="caption"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {errorMessage}
                  </p>
                )
              )}
          </Box>

          {/* Add New Business Partner Button */}
          {!hide && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                disabled={isFilled?.[tableIndex] || disabled}
                endIcon={<Add />}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  color: "#1C486B",
                  width: "18rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add New Region
              </Button>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default DropDownTable;
